import React, { ReactNode, useContext } from 'react';
import { PrecheckContext } from '../../contexts/PrecheckContext';
import { FormattedMessage } from 'react-intl';
import NameAndMobile from './NameAndMobile';
// const trailerTypeList = ['Dry Van', 'Refrigerated'];
const trailerSizeList = ['46', '48', '53', '57'];

const LiveLoad = () => {
    const { precheckInfo, setPrecheckInfo } = useContext(PrecheckContext);
    
    return (
        <>
            <NameAndMobile />
            <div className="form-group mb-20">
                <label htmlFor="pickupNumber">
                    <FormattedMessage
                        id="driverInfoEntryInputLabelPickupOrDelivery"
                        defaultMessage="Pick-up or Delivery Number"
                    />
                </label>
                <FormattedMessage
                    id="driverInfoEntryInputPlaceholderPickupOrDelivery"
                    defaultMessage="Example: 34xxxxxx (8 digits)">
                    {(placeholder: ReactNode) => (
                        <input
                            type="text"
                            className="form-control"
                            name="pickupNumber"
                            id="pickupNumber"
                            placeholder={placeholder as string}
                            value={precheckInfo.submittedReferenceId}
                            onChange={(e) =>
                                setPrecheckInfo({
                                    ...precheckInfo,
                                    submittedReferenceId: e.target.value
                                })
                            }
                        />
                    )}
                </FormattedMessage>
            </div>
            <div className="form-group mb-20">
                <label htmlFor="trailerNumber">
                    <FormattedMessage
                        id="driverInfoEntryInputLabelTrailerNumber"
                        defaultMessage="Trailer Number"
                    />
                </label>
                <input
                    type="text"
                    className="form-control"
                    name="trailerNumber"
                    id="trailerNumber"
                    placeholder="abc123"
                    value={precheckInfo.submittedTrailerNumber}
                    onChange={(e) =>
                        setPrecheckInfo({
                            ...precheckInfo,
                            submittedTrailerNumber: e.target.value
                        })
                    }
                />
            </div>
            {/* <div className="form-group mb-20">
                <label htmlFor="destination">
                    <FormattedMessage
                        id="driverInfoEntryInputLabelDestination"
                        defaultMessage="Trailer Number"
                    />
                </label>
                <input
                    type="text"
                    className="form-control"
                    name="destination"
                    id="destination"
                    placeholder="123 Philly St. Ontario, CA 91761"
                    value={precheckInfo.submittedDestination}
                    onChange={(e) =>
                        setPrecheckInfo({
                            ...precheckInfo,
                            submittedDestination: e.target.value
                        })
                    }
                />
            </div> */}
            {/* <div className="form-group mb-20">
                <label htmlFor="driverCarrier">
                    <FormattedMessage
                        id="driverInfoEntryInputLabelCarrierBroker"
                        defaultMessage="Carrier/Broker"
                    />
                </label>
                <br />
                <input
                    type="text"
                    className="form-control"
                    name="driverCarrier"
                    id="driverCarrier"
                    placeholder="Generic Transportation"
                    value={precheckInfo.submittedCarrierName}
                    onChange={(e) =>
                        setPrecheckInfo({
                            ...precheckInfo,
                            submittedCarrierName: e.target.value,
                            submittedCarrierScac: 'STATIC_HARDCODED'
                        })
                    }
                />
            </div> */}
            {/* <label className="mb-2">
                <FormattedMessage
                    id="driverInfoEntryInputLabelTrailerType"
                    defaultMessage="Trailer Type"
                />
            </label>
            <div className="check-box-wrapper d-flex">
                {trailerTypeList.map((type: string) => {
                    return (
                        <div className="form-check" key={type}>
                            <input
                                className="form-check-input"
                                type="radio"
                                name="trailerId"
                                id={`type-${type}`}
                                hidden
                                checked={precheckInfo.trailerType === type}
                                onChange={(event) =>
                                    setPrecheckInfo({
                                        ...precheckInfo,
                                        trailerType: event.target.value
                                    })
                                }
                                value={type}
                            />
                            <label className="form-check-label" htmlFor={`type-${type}`}>
                                {type}
                            </label>
                        </div>
                    );
                })}
            </div> */}
            <label className="mb-2">
                <FormattedMessage
                    id="driverInfoEntryInputLabelTrailerSize"
                    defaultMessage="Trailer Size"
                />
            </label>
            <div className="check-box-wrapper d-flex">
                {trailerSizeList.map((trailerSize: string) => {
                    return (
                        <div className="form-check" key={trailerSize}>
                            <input
                                className="form-check-input"
                                type="radio"
                                name="trailerSize"
                                id={`size-${trailerSize}`}
                                hidden
                                checked={
                                    String(trailerSize) === precheckInfo.submittedTrailerLength
                                }
                                onChange={(e) =>
                                    setPrecheckInfo({
                                        ...precheckInfo,
                                        submittedTrailerLength: e.target.value
                                    })
                                }
                                value={trailerSize}
                            />
                            <label className="form-check-label" htmlFor={`size-${trailerSize}`}>
                                {trailerSize}
                            </label>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default LiveLoad;
